import { AuthService } from '@mds/angular-core';
import { INavigationItem } from '@mds/angular-layout-primeng';
import { map, Observable } from 'rxjs';
import { OrganizationSwitchService } from '../services/organization-switch.service';

export function createProfileItems(
  authService: AuthService,
  organizationSwitchService: OrganizationSwitchService
): Observable<INavigationItem[]> {
  return authService.isAuthenticated$.pipe(
    map((isAuthenticated) => {
      const menuItem = isAuthenticated
        ? [
            {
              labelResource: 'Iam.OrganizationSwitch.Title',
              icon: 'mds mds-organization',
              command: () => organizationSwitchService.openOrganizationSwitch(),
              id: 'switch-organization',
            },
          ]
        : [];

      return menuItem;
    })
  );
}
